// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/Investors.css - UPDATED FOR LIGHT THEME */

.investors-page-wrapper {
  width: 100%;
  background-color: var(--bg-secondary); /* Use light secondary background for the page */
  padding-bottom: 4rem; /* Add padding at the bottom */
  padding-top: var(--navbar-height); /* Add space for navbar */
}

.investors-hero {
  padding: clamp(3rem, 8vh, 5rem) 0;
  background: var(--gradient-hero); /* Use light hero gradient */
  text-align: center;
  color: var(--text-primary); /* Dark text */
  border-bottom: 1px solid var(--border-primary); /* Add subtle separator */
}

.investors-hero h1 {
  font-size: clamp(2rem, 6vw, 3.2rem);
  font-weight: 600;
  margin-bottom: 1rem;
  color: var(--text-primary); /* Dark text */
}

.investors-hero .hero-subtext {
  font-size: clamp(1rem, 2.5vw, 1.2rem);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  color: var(--text-secondary); /* Medium gray text */
  line-height: 1.6;
}

.page-content.container {
  padding-top: 4rem; /* Increased top padding */
  padding-bottom: 3rem;
}

.investors-section {
  padding: clamp(2rem, 5vw, 3rem) 0;
  margin-bottom: 3rem; /* Increased spacing */
  text-align: center;
}

.investors-section h2 {
  font-size: clamp(1.8rem, 5vw, 2.5rem);
  color: var(--text-accent); /* Red accent */
  margin-bottom: 2.5rem;
  font-weight: 600;
}

.investors-section p {
  color: var(--text-secondary); /* Medium gray text */
  font-size: 1.1rem;
  line-height: 1.7;
  max-width: 850px;
  margin: 0 auto 1.5rem auto; /* Increased bottom margin */
}


/* Styles for Numbered Feature List */
.standout-section {
  text-align: left;
  background: var(--bg-primary); /* White background for this section */
  padding: 3rem 2rem; /* Add padding */
  border-radius: var(--border-radius-2xl); /* Add rounding */
  border: 1px solid var(--border-primary); /* Add border */
  box-shadow: var(--shadow-xl); /* Add shadow */
  margin-bottom: 4rem; /* Increase spacing */
}

/* Center the heading within the standout section */
.standout-section h2 {
  text-align: center;
}

.numbered-feature-list {
  display: flex;
  flex-direction: column;
  gap: 2rem; /* Increased gap */
  max-width: 900px;
  margin: 0 auto;
}

.numbered-feature-item {
  display: flex;
  align-items: flex-start;
  gap: 1.5rem;
  padding-bottom: 2rem; /* Increased padding */
  border-bottom: 1px solid var(--border-primary); /* Light border */
}

.numbered-feature-item:last-child {
  border-bottom: none;
  padding-bottom: 0; /* Remove bottom padding for last item */
}

.feature-number {
  font-size: clamp(2.5rem, 6vw, 3.2rem);
  font-weight: 600;
  color: var(--border-primary); /* Light gray, less prominent */
  line-height: 1;
  margin-top: -0.25rem;
}

.feature-text h3 {
  font-size: clamp(1.2rem, 3vw, 1.4rem);
  color: var(--text-primary); /* Dark text */
  font-weight: 600; /* Bolder */
  margin-bottom: 0.75rem;
}

.feature-text p {
  font-size: 1rem;
  color: var(--text-secondary); /* Medium gray text */
  line-height: 1.6;
  text-align: left;
  margin: 0;
}


/* Contact Section (Light Theme) */
.contact-section {
  background: var(--bg-primary); /* White background */
  color: var(--text-primary); /* Dark text */
  border-radius: var(--border-radius-2xl); /* Rounded */
  padding: clamp(2rem, 5vw, 3.5rem);
  text-align: center;
  border: 1px solid var(--border-primary); /* Add border */
  box-shadow: var(--shadow-xl); /* Add shadow */
}

.contact-section h2,
.contact-section p {
  color: var(--text-primary); /* Ensure dark text */
}
.contact-section p { /* Slightly adjust paragraph text */
  color: var(--text-secondary);
}

.contact-investors {
  margin: 2rem 0; /* Increased margin */
}

/* Use primary button style */
.investor-email-link {
  display: inline-flex; /* Use flex for icon alignment */
  align-items: center;
  gap: 0.5rem; /* Space between icon and text */
  background-image: var(--gradient-button); /* Red gradient */
  background-color: var(--primary-red-medium); /* Fallback color */
  color: var(--text-on-gradient); /* White text */
  padding: 0.9rem 1.8rem; /* Adjusted padding */
  border-radius: var(--border-radius-full); /* Pill shape */
  text-decoration: none;
  font-weight: 600; /* Bolder */
  font-size: 1.1rem;
  transition: all 0.3s ease;
  margin-bottom: 1.5rem; /* Increased margin */
  box-shadow: var(--shadow-lg);
}

.investor-email-link:hover {
  box-shadow: var(--shadow-button-hover); /* Reddish hover shadow */
  transform: scale(1.03); /* Slight scale */
  /* Gradient remains the same on hover */
}

.invest-cta {
  font-weight: 600;
  font-size: 1.2rem;
  margin-top: 1.5rem; /* Increased margin */
  color: var(--text-primary); /* Dark text */
}`, "",{"version":3,"sources":["webpack://./src/styles/Investors.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,WAAW;EACX,qCAAqC,EAAE,gDAAgD;EACvF,oBAAoB,EAAE,8BAA8B;EACpD,iCAAiC,EAAE,yBAAyB;AAC9D;;AAEA;EACE,iCAAiC;EACjC,gCAAgC,EAAE,4BAA4B;EAC9D,kBAAkB;EAClB,0BAA0B,EAAE,cAAc;EAC1C,8CAA8C,EAAE,yBAAyB;AAC3E;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B,EAAE,cAAc;AAC5C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,0BAA0B;EAC7C,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB,EAAE,sBAAsB;EAC3C,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB,EAAE,eAAe;EAC1C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B,EAAE,qBAAqB;EACnD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B,EAAE,4BAA4B;AAC1D;;;AAGA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,6BAA6B,EAAE,sCAAsC;EACrE,kBAAkB,EAAE,gBAAgB;EACpC,uCAAuC,EAAE,iBAAiB;EAC1D,uCAAuC,EAAE,eAAe;EACxD,4BAA4B,EAAE,eAAe;EAC7C,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,kBAAkB;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,oBAAoB,EAAE,sBAAsB;EAC5C,8CAA8C,EAAE,iBAAiB;AACnE;;AAEA;EACE,mBAAmB;EACnB,iBAAiB,EAAE,wCAAwC;AAC7D;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B,EAAE,+BAA+B;EAC7D,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B,EAAE,cAAc;EAC1C,gBAAgB,EAAE,WAAW;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,4BAA4B,EAAE,qBAAqB;EACnD,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;;AAGA,kCAAkC;AAClC;EACE,6BAA6B,EAAE,qBAAqB;EACpD,0BAA0B,EAAE,cAAc;EAC1C,uCAAuC,EAAE,YAAY;EACrD,iCAAiC;EACjC,kBAAkB;EAClB,uCAAuC,EAAE,eAAe;EACxD,4BAA4B,EAAE,eAAe;AAC/C;;AAEA;;EAEE,0BAA0B,EAAE,qBAAqB;AACnD;AACA,qBAAqB,mCAAmC;EACtD,4BAA4B;AAC9B;;AAEA;EACE,cAAc,EAAE,qBAAqB;AACvC;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB,EAAE,gCAAgC;EACtD,mBAAmB;EACnB,WAAW,EAAE,gCAAgC;EAC7C,wCAAwC,EAAE,iBAAiB;EAC3D,2CAA2C,EAAE,mBAAmB;EAChE,8BAA8B,EAAE,eAAe;EAC/C,sBAAsB,EAAE,qBAAqB;EAC7C,wCAAwC,EAAE,eAAe;EACzD,qBAAqB;EACrB,gBAAgB,EAAE,WAAW;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB,EAAE,qBAAqB;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC,EAAE,yBAAyB;EACjE,sBAAsB,EAAE,iBAAiB;EACzC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAE,qBAAqB;EACzC,0BAA0B,EAAE,cAAc;AAC5C","sourcesContent":["/* frontend/src/styles/Investors.css - UPDATED FOR LIGHT THEME */\n\n.investors-page-wrapper {\n  width: 100%;\n  background-color: var(--bg-secondary); /* Use light secondary background for the page */\n  padding-bottom: 4rem; /* Add padding at the bottom */\n  padding-top: var(--navbar-height); /* Add space for navbar */\n}\n\n.investors-hero {\n  padding: clamp(3rem, 8vh, 5rem) 0;\n  background: var(--gradient-hero); /* Use light hero gradient */\n  text-align: center;\n  color: var(--text-primary); /* Dark text */\n  border-bottom: 1px solid var(--border-primary); /* Add subtle separator */\n}\n\n.investors-hero h1 {\n  font-size: clamp(2rem, 6vw, 3.2rem);\n  font-weight: 600;\n  margin-bottom: 1rem;\n  color: var(--text-primary); /* Dark text */\n}\n\n.investors-hero .hero-subtext {\n  font-size: clamp(1rem, 2.5vw, 1.2rem);\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n  color: var(--text-secondary); /* Medium gray text */\n  line-height: 1.6;\n}\n\n.page-content.container {\n  padding-top: 4rem; /* Increased top padding */\n  padding-bottom: 3rem;\n}\n\n.investors-section {\n  padding: clamp(2rem, 5vw, 3rem) 0;\n  margin-bottom: 3rem; /* Increased spacing */\n  text-align: center;\n}\n\n.investors-section h2 {\n  font-size: clamp(1.8rem, 5vw, 2.5rem);\n  color: var(--text-accent); /* Red accent */\n  margin-bottom: 2.5rem;\n  font-weight: 600;\n}\n\n.investors-section p {\n  color: var(--text-secondary); /* Medium gray text */\n  font-size: 1.1rem;\n  line-height: 1.7;\n  max-width: 850px;\n  margin: 0 auto 1.5rem auto; /* Increased bottom margin */\n}\n\n\n/* Styles for Numbered Feature List */\n.standout-section {\n  text-align: left;\n  background: var(--bg-primary); /* White background for this section */\n  padding: 3rem 2rem; /* Add padding */\n  border-radius: var(--border-radius-2xl); /* Add rounding */\n  border: 1px solid var(--border-primary); /* Add border */\n  box-shadow: var(--shadow-xl); /* Add shadow */\n  margin-bottom: 4rem; /* Increase spacing */\n}\n\n/* Center the heading within the standout section */\n.standout-section h2 {\n  text-align: center;\n}\n\n.numbered-feature-list {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem; /* Increased gap */\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.numbered-feature-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 1.5rem;\n  padding-bottom: 2rem; /* Increased padding */\n  border-bottom: 1px solid var(--border-primary); /* Light border */\n}\n\n.numbered-feature-item:last-child {\n  border-bottom: none;\n  padding-bottom: 0; /* Remove bottom padding for last item */\n}\n\n.feature-number {\n  font-size: clamp(2.5rem, 6vw, 3.2rem);\n  font-weight: 600;\n  color: var(--border-primary); /* Light gray, less prominent */\n  line-height: 1;\n  margin-top: -0.25rem;\n}\n\n.feature-text h3 {\n  font-size: clamp(1.2rem, 3vw, 1.4rem);\n  color: var(--text-primary); /* Dark text */\n  font-weight: 600; /* Bolder */\n  margin-bottom: 0.75rem;\n}\n\n.feature-text p {\n  font-size: 1rem;\n  color: var(--text-secondary); /* Medium gray text */\n  line-height: 1.6;\n  text-align: left;\n  margin: 0;\n}\n\n\n/* Contact Section (Light Theme) */\n.contact-section {\n  background: var(--bg-primary); /* White background */\n  color: var(--text-primary); /* Dark text */\n  border-radius: var(--border-radius-2xl); /* Rounded */\n  padding: clamp(2rem, 5vw, 3.5rem);\n  text-align: center;\n  border: 1px solid var(--border-primary); /* Add border */\n  box-shadow: var(--shadow-xl); /* Add shadow */\n}\n\n.contact-section h2,\n.contact-section p {\n  color: var(--text-primary); /* Ensure dark text */\n}\n.contact-section p { /* Slightly adjust paragraph text */\n  color: var(--text-secondary);\n}\n\n.contact-investors {\n  margin: 2rem 0; /* Increased margin */\n}\n\n/* Use primary button style */\n.investor-email-link {\n  display: inline-flex; /* Use flex for icon alignment */\n  align-items: center;\n  gap: 0.5rem; /* Space between icon and text */\n  background-image: var(--gradient-button); /* Red gradient */\n  background-color: var(--primary-red-medium); /* Fallback color */\n  color: var(--text-on-gradient); /* White text */\n  padding: 0.9rem 1.8rem; /* Adjusted padding */\n  border-radius: var(--border-radius-full); /* Pill shape */\n  text-decoration: none;\n  font-weight: 600; /* Bolder */\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  margin-bottom: 1.5rem; /* Increased margin */\n  box-shadow: var(--shadow-lg);\n}\n\n.investor-email-link:hover {\n  box-shadow: var(--shadow-button-hover); /* Reddish hover shadow */\n  transform: scale(1.03); /* Slight scale */\n  /* Gradient remains the same on hover */\n}\n\n.invest-cta {\n  font-weight: 600;\n  font-size: 1.2rem;\n  margin-top: 1.5rem; /* Increased margin */\n  color: var(--text-primary); /* Dark text */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
